export default "__VITE_ASSET__Cjb2OB81__"